<div class="flex flex-col h-full place-content-between" *ngIf="{ serviceAdvisors: saviDialogData.serviceAdvisors$ | async,
    linkedServiceVisit: svcVehicleDiagnosticsRootFacade.linkedServiceVisit$ | async,
    serviceVisitsByVin: svcVehicleDiagnosticsRootFacade.serviceVisitsByVin$ | async,
    serviceVisitsByDealer: svcVehicleDiagnosticsRootFacade.serviceVisitsByDealer$ | async,
    loading: dataLoading$ | async,
    alreadyLinkedServiceVisitIds: svcVehicleDiagnosticsRootFacade.getAlreadyLinkedServiceVisitIds$ | async,
    serviceVisitsByVinError: svcVehicleDiagnosticsRootFacade.serviceVisitsByVinError$ | async,
    serviceVisitsByDealerError: svcVehicleDiagnosticsRootFacade.serviceVisitsByDealerError$ | async} as templateData">
  <div class="pb-4">
    <form id="saviFilterForm" [formGroup]="saviFilterForm">
      <div class="flex flex-row flex-wrap place-content-between">
        <mat-form-field appearance="outline" class="w-1/2 sm:w-1/3 px-1">
          <mat-label>Date From</mat-label>
          <input matInput autocomplete="off" [matDatepicker]="dateFromPicker" name="fromDate" formControlName="dateFrom"
            [max]="maxDate" placeholder="MM/DD/YYYY">
          <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
          <mat-datepicker #dateFromPicker></mat-datepicker>
          <mat-error *ngIf="saviFilterForm.get('dateFrom')?.errors">
            {{saviFilterForm.get('dateFrom')?.errors | inputError}}
          </mat-error>
        </mat-form-field>


        <mat-form-field appearance="outline" class="w-1/2 sm:w-1/3 px-1">
          <mat-label>Date To</mat-label>
          <input matInput autocomplete="off" [matDatepicker]="dateToPicker" placeholder="MM/DD/YYYY" name="toDate"
            formControlName="dateTo" [max]="maxDate">
          <mat-datepicker-toggle matSuffix [for]="dateToPicker"></mat-datepicker-toggle>
          <mat-datepicker #dateToPicker></mat-datepicker>
          <mat-error *ngIf="saviFilterForm.get('dateTo')?.errors">
            {{saviFilterForm.get('dateTo')?.errors | inputError}}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-1/2 sm:w-1/3 px-1">
          <mat-label>Service Advisor</mat-label>
          <mat-select formControlName="serviceAdvisor">
            <mat-option>None</mat-option>
            <mat-option *ngFor="let sa of templateData.serviceAdvisors | sortNamesBy: ['lastName']" [value]="sa">
              {{sa.embedded?.associate?.lastName}}, {{sa.embedded?.associate?.firstName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-error *ngIf="saviFilterForm.errors" class="-mt-5 text-xs ml-1">
          {{saviFilterForm.errors['dates']}}
        </mat-error>
      </div>

      <div class="flex flex-row place-content-between">
        <div class="form-field">
          <div class="flex flex-row space-x-2 ">
            <span class="pt-0.5">By VIN</span>
            <mat-slide-toggle matInput formControlName="saviVinOrDealer"
              (change)="searchSaviRecords(saviFilterForm.value, templateData.serviceVisitsByVin, templateData.serviceVisitsByDealer, templateData.linkedServiceVisit?.serviceVisitId)">
            </mat-slide-toggle>
            <span class="pt-0.5">By Dealer</span>
          </div>
        </div>

        <div class="flex flex-row place-content-center place-items-center button-container">
          <button id="apply-filters-button" type="button" mat-raised-button color="primary"
            (click)="searchSaviRecords(saviFilterForm.value, templateData.serviceVisitsByVin, templateData.serviceVisitsByDealer, templateData.linkedServiceVisit?.serviceVisitId)"
            [disabled]="saviFilterForm.invalid">Search</button>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="templateData.loading === true; else loaded">
    <div class="flex flex-row border border-solid border-grey-300 rounded-lg w-full">
      <div class="flex flex-col w-full bg-grey-300 rounded-lg">
        <div class="flex flex-col pt-3 animated-background h-96 rounded-lg"></div>
      </div>
    </div>
  </div>
  <ng-template #loaded>
    <div class="flex h-152 w-full overflow-y-scroll border border-grey-300 rounded-lg px-2"
      *ngIf="saviRecords$ | async as saviRecords">
      <div class="w-full relative" *ngIf="saviRecords.length > 0; else noSaviRecords">
        <table class="w-full text-sm text-left">
          <thead class="text-xs text-grey-700 uppercase sticky top-0 opacity-100 bg-white">
            <tr>
              <th class="py-3 px-1">
                VIN
              </th>
              <th class="py-3 px-1">
                Odo
              </th>
              <th class="py-3 px-1">
                Year
              </th>
              <th class="py-3 px-1">
                Make
              </th>
              <th class="py-3 px-1">
                Model
              </th>
              <th class="py-3 px-1">
                Color
              </th>
              <th class="py-3 px-1">
                E. Light
              </th>
              <th class="py-3 px-1">
                Check-In
              </th>
              <!-- <th  class="py-3 px-1">
              Advisor
            </th> -->
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white border-grey-300" *ngFor="let savi of saviRecords; let i = index; let last = last "
              (click)="selectSaviRecord(savi.serviceVisit, i)"
              [ngClass]="{ 'bg-grey-100': selectedSaviRecord === i,
              'bg-grey-200': savi.serviceVisit.serviceVisitId === templateData?.linkedServiceVisit?.serviceVisitId && selectedSaviRecord === -1,
              'border-b-0': last,
              'border-b': !last,
              'pointer-events-none': savi.serviceVisit.vin !== saviDialogData.vin || templateData?.alreadyLinkedServiceVisitIds?.includes(savi.serviceVisit.serviceVisitId) || !savi.isWithinADay,
              'text-grey-400': savi.serviceVisit.vin !== saviDialogData.vin || (templateData?.alreadyLinkedServiceVisitIds?.includes(savi.serviceVisit.serviceVisitId) && savi.serviceVisit.serviceVisitId !== templateData?.linkedServiceVisit?.serviceVisitId) || !savi.isWithinADay }">
              <td class="flex flex-row py-3 px-1 font-medium text-gray-900 whitespace-nowrap">
                <span>
                  {{savi.serviceVisit.vin}}
                </span>
                <span
                  *ngIf="savi?.serviceVisit.serviceVisitId === templateData?.linkedServiceVisit?.serviceVisitId; else checkPreviouslyLinked"
                  class="pl-2"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                    class="w-5 h-5">
                    <path
                      d="M12.232 4.232a2.5 2.5 0 013.536 3.536l-1.225 1.224a.75.75 0 001.061 1.06l1.224-1.224a4 4 0 00-5.656-5.656l-3 3a4 4 0 00.225 5.865.75.75 0 00.977-1.138 2.5 2.5 0 01-.142-3.667l3-3z" />
                    <path
                      d="M11.603 7.963a.75.75 0 00-.977 1.138 2.5 2.5 0 01.142 3.667l-3 3a2.5 2.5 0 01-3.536-3.536l1.225-1.224a.75.75 0 00-1.061-1.06l-1.224 1.224a4 4 0 105.656 5.656l3-3a4 4 0 00-.225-5.865z" />
                  </svg>
                </span>
                <ng-template #checkPreviouslyLinked>
                  <span class="pl-2"
                    *ngIf="templateData?.alreadyLinkedServiceVisitIds?.includes(savi.serviceVisit.serviceVisitId); else checkWithinADay">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
                      <path fill-rule="evenodd"
                        d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z"
                        clip-rule="evenodd" />
                    </svg>
                  </span>
                  <ng-template #checkWithinADay>
                    <span class="pl-2" *ngIf="!savi.isWithinADay">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-5 h-5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </span>
                  </ng-template>
                </ng-template>
              </td>
              <td class="py-3 px-1">
                {{savi.serviceVisit.odometer}}
              </td>
              <td class="py-3 px-1">
                {{savi.serviceVisit.modelYear}}
              </td>
              <td class="py-3 px-1">
                {{savi.serviceVisit.makeName}}
              </td>
              <td class="py-3 px-1">
                {{savi.serviceVisit.modelName}}
              </td>
              <td class="py-3 px-1">
                {{savi.serviceVisit.color !== "null" ? savi.serviceVisit.color : 'N/A'}}
              </td>
              <td class="py-3 px-1">
                {{savi.serviceVisit.engineLight}}
              </td>
              <td class="py-3 px-1">
                {{savi.serviceVisit.checkInDate | date: 'shortDate'}},
                {{savi.serviceVisit.checkInTime.toString().substring(0,5)}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noSaviRecords>
        <div *ngIf="saviFilterForm.get('saviVinOrDealer').value === false"
          class="flex w-full h-full items-center place-content-center text-lg text-red-500">
          <div *ngIf="templateData.serviceVisitsByVinError; else noServiceVisits">
            {{templateData.serviceVisitsByVinError?.statusCode === 403 ? templateData.serviceVisitsByVinError.error :
            'Error retrieving service visits by VIN'}}
          </div>
        </div>
        <div *ngIf="saviFilterForm.get('saviVinOrDealer').value === true"
          class="flex w-full h-full items-center place-content-center text-lg text-red-500">
          <div *ngIf="templateData.serviceVisitsByDealerError; else noServiceVisits">
            {{templateData.serviceVisitsByDealerError?.statusCode === 403 ?
            templateData.serviceVisitsByDealerError.error :
            'Error retrieving service visits by Dealer'}}
          </div>
        </div>
        <ng-template #noServiceVisits>
          <div class="flex w-full h-full items-center place-content-center text-lg text-grey-500">
            No service visits found
          </div>
        </ng-template>
      </ng-template>
    </div>
  </ng-template>
  <div class="flex flex-row place-content-between pt-3">
    <div class="w-7"></div>
    <div class="space-x-4">
      <button mat-button (click)="cancel()">Cancel</button>
      <button mat-button (click)="linkSaviRecord(selectedSaviRecordObject)"
        [disabled]="selectedSaviRecord < 0">Link</button>
    </div>
  </div>
</div>